import { RATES } from "@/config/constants";
import { formatCurrency } from "@/lib/utils";

type Compensation = {
  amount?: number | string | null;
  market_rate?: boolean;
  rate?: string;
};

export function isMarketRateCompensation(compensation: Compensation) {
  return Boolean(compensation?.market_rate);
}

export function hasCompensationValue(compensation: Compensation) {
  return (
    isMarketRateCompensation(compensation) || Number(compensation.amount) > 0
  );
}

export function formatCompensation(compensation: Compensation) {
  if (isMarketRateCompensation(compensation)) {
    return "Market rate";
  }

  const rateLabel = RATES.find(
    (rate) => rate.value === compensation.rate
  )?.label;
  return `${formatCurrency(compensation.amount ?? 0)} ${rateLabel ?? "-"}`;
}
